/**
 * 板块编辑 store
 */
import blkEditApi from '../../api/blk.edit.api'

const state = {
	showBlkEdit: false,
	editType: 'addTo', // addTo: 追加， amend 修改
	nodeParams: {
		divNodeId: '',
		dlNodeId: ''
	}
}
const mutations = {
	setBlkEditState(state, data) {
		for (let key in data) {
			if (data.hasOwnProperty(key)) {
				state[key] = data[key]
			}
		}
	}
}
const getters = {}
const actions = {
	getProdAndArtPage(context, params) {
		return blkEditApi.getProdAndArtPage(params)
	},
	editProdAndArtPage(context, data) {
		return blkEditApi.editProdAndArtPage(data)
	},
	// 删除当前关联文章或产品
	removeDelNodes(context, params) {
		return blkEditApi.removeDelNodes(params)
	},
	// 获取已经关联的页面，用于数据回显
	getEchoPage(context, params) {
		return blkEditApi.getEchoPage(params)
	},

	// 首页点选修改
	editIndexProdAndArtPage(context, data) {
		return blkEditApi.editIndexProdAndArtPage(data)
	},
	// 自定义板块
	editCustomBlk(context, data) {
		return blkEditApi.editCustomBlk(data)
	},
	// 自定义板块 自动读取数据 保存接口
	customReadBlk(context, data) {
		return blkEditApi.customReadBlk(data)
	},

	// 文章列表，产品列表 自定义板块
	layoutSave(context, data) {
		return blkEditApi.layoutSave(data)
	},
	layoutSaveView(context, params) {
		return blkEditApi.layoutSaveView(params)
	}
}

const blkEdit = {
	state,
	mutations,
	getters,
	actions,
	namespaced: true
}

export default blkEdit
